import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { range } from 'lodash-es';

import { ArrowDirection } from './slideshow.model';

@Component({
    standalone: true,
    selector: 'ms-slideshow-indicators',
    templateUrl: './indicators.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndicatorsComponent implements OnInit, OnChanges {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() items: any[] = [];
    @Input() realtotalslidecount = 0;
    @Input() currentSlideIndex = 0;
    @Input() indicatorArrow = false;
    @Output() select = new EventEmitter<number | ArrowDirection>();

    indicators: number[];

    arrowDirections = ArrowDirection;

    ngOnInit(): void {
        this.indicators = range(this.realtotalslidecount);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const realtotalslidecountchanged = changes['realtotalslidecount'];
        if (realtotalslidecountchanged) {
            this.indicators = range(this.realtotalslidecount);
        }
    }

    isActive(crtIndex: number): boolean {
        if (this.realtotalslidecount < this.items.length) {
            return this.currentSlideIndex > this.realtotalslidecount - 1
                ? crtIndex === this.currentSlideIndex - this.realtotalslidecount
                : crtIndex === this.currentSlideIndex;
        }

        return crtIndex === this.currentSlideIndex;
    }

    indicatorClick(index: number): void {
        this.select.emit(index);
    }

    arrowClick(direction: ArrowDirection): void {
        this.select.emit(direction);
    }
}
